module.exports = __webpack_public_path__ + "1793882494189/images/south-america.e828146.png";